/* eslint-disable react/no-danger */

import React from 'react';

import './HomepageBanner.scss';

const HomepageBanner = (data) => {
  const { heroImage, title, link } = data;

  return (
    <section className="homepage-banner">
      <div className="homepage-banner__content">
        {heroImage && (
          <div className="homepage-banner__image-container">
            <img
              src={heroImage.url}
              alt="
      Gaviscon fireman standing next
      to a bottle of Gaviscon Dual Action Liquid peppermint
      flavour and a box of Gaviscon Dual Action peppermint tablets.
      A teal and pink roulette wheel shows key symptoms of heartburn & indigestion,
      including stomach discomfort, chest burning, and throat burning.
    "
            />
          </div>
        )}

        <div className="homepage-banner__heading">
          {title && (
            <div className="homepage-banner__title" dangerouslySetInnerHTML={{ __html: title }} />
          )}
          {link && (
            <div className="homepage-banner__button" dangerouslySetInnerHTML={{ __html: link }} />
          )}
        </div>
      </div>
    </section>
  );
};

export default HomepageBanner;
